import { useEffect } from "react";

import { toast } from "react-toastify";

import { ToastPosition } from "@atoms/Toast/constants/toast.constants";
import { showToast } from "@atoms/Toast/Toast";

type Props = {
  message: string;
  position: ToastPosition;
};

const ToastMessageContainer = ({ message, position = "bottomLeft" }: Props) => {
  useEffect(() => {
    // 모든 기존 토스트 제거(하나만 표출)
    toast.dismiss();

    showToast({
      icon: "error",
      backgroundColor: "hotPink",
      text: message,
      position,
      autoClose: 5000,
    });
  }, [message, position]);

  return <></>;
};

export default ToastMessageContainer;
